import { I as Icon, _ as __assign } from './loadable.esm-8884282c.js';
import React from 'react';
import 'styled-components';

var ArrowLeftIcon = function (props) { return (React.createElement(Icon, __assign({}, props, { viewBox: "0 0 8 14" }),
    React.createElement("path", { d: "M.797 6.797a1 1 0 00.219.625l4.625 5.781 1.562-1.25-4.126-5.156 4.12-5.156L5.635.391 1.01 6.172a1 1 0 00-.213.625z" }))); };

export { ArrowLeftIcon as default };
